import React from "react";
import { Patient } from "../../../../Types";
import { LicenceCard } from "./LicenceCard";
export const HomeContainer: React.FC<{ patient: Patient }> = ({ patient }) => {
  return (
    <div>
      <LicenceCard patient={patient} />
    </div>
  );
};
